import { ActivatedRoute } from '@angular/router';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { Component } from "@angular/core";

@Component({
    selector: 'yt-dokument-stavka-update-container',
    templateUrl: './dokument-stavka-update-container.component.html',
    providers: [
        InlineContainerService
    ]
})
export class DokumentStavkaUpdateContainer<T extends BaseEntity> extends BaseInlineContainer<T> {
    constructor(inlineContainerService: InlineContainerService<T>,
                activatedRoute: ActivatedRoute,
                userService: UserService){
        super(inlineContainerService, activatedRoute, userService);
    }
}